import { render } from "./FaceRecognitionDirective.vue?vue&type=template&id=27dd85e2&scoped=true"
import script from "./FaceRecognitionDirective.vue?vue&type=script&lang=js"
export * from "./FaceRecognitionDirective.vue?vue&type=script&lang=js"

import "./FaceRecognitionDirective.vue?vue&type=style&index=0&id=27dd85e2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27dd85e2"]])

export default __exports__